/**
 * The modal-title glyph: 16px at stroke 1.5, on every surface. Plain data so the DOM callout (featureCalloutDom.ts)
 * draws the same glyph as ModalTitle.tsx without importing React; ModalTitle re-exports it.
 */
export const MODAL_GLYPH_PROPS = { size: 16, strokeWidth: 1.5 };
//# sourceMappingURL=modalGlyph.js.map